import React from "react";
import PricingTable from "./PricingTable";
import BoldCell from "./BoldCell";

import { applicationPricing } from "../../data/pricing-page-data";

type CICDTableProps = {
  currency: string
};

const CICDTable: React.FC<CICDTableProps> = ({ currency, ...props }) => {

  return (
    <PricingTable>
      <tbody>
        <tr>
          <BoldCell>Build resources included</BoldCell>
          <td>
            <strong>CPU</strong>
            <br/>
            <span>2.5 CPU-hours/project/month</span>
            <br/>
            <br/>
            <strong>Memory</strong>
            <br/>
            <span>5 GB-hours/project/month</span>
          </td>
        </tr>
        <tr>
          <BoldCell>Additional build resources</BoldCell>
          <td>
            <strong>CPU</strong>
            <br/>
            <span>{`${applicationPricing.cpuHourly[currency]} CPU-hours/project/month`}</span>
            <br/><br/>
            <strong>Memory</strong>
            <br/>
            <span>{`${applicationPricing.memoryHourly[currency]} GB-hours/project/month`}</span>
          </td>
        </tr>
      </tbody>
    </PricingTable>
  );
};

export default CICDTable;
